import React, {Fragment} from 'react';
import {Form, Submit, Edit, Breadcrumbs, List} from 'components';
import {api} from 'helpers';
import {store} from 'store';

const boundaries = {
  min: 6,
  max: 15,
}

export function Password() {
  return (
    <Form className="medium-spacing" onSubmit={submit} validate={validate}>
      <List small-gutter>
        <div>
          <b className="label">Old password</b>
          <Edit name="password" type="password" required />
        </div>
        <div>
          <b className="label">New password</b>
          <Edit name="new-password" type="password" required validate={validatePassword} />
        </div>
        <div>
          <b className="label">Retype new password</b>
          <Edit name="new-password-confirm" type="password" required validate={validatePassword} />
          <p className="secondary small small-spacing">*must be at least { boundaries.min } and no longer than { boundaries.max } characters</p>
        </div>
        <footer className="smedium-spacing">
          <Submit>
            {[ 'Update', 'Updating..', 'Saved' ]}
          </Submit>
        </footer>
      </List>
    </Form>
  );
}

function validate(values) {
  if (values['new-password'] != values['new-password-confirm']) {
    return {
      'new-password-confirm': 'do not match'
    }
  }
}

function validatePassword(value) {
  if (!value) {
    return 'required';
  } else if (value.length < boundaries.min) {
    return 'too short';
  } else if (value.length > boundaries.max) {
    return 'too long';
  }
}

async function submit(values, { resetForm, setFieldError }) {
  try {
    await api('/change-password/', values);
    store.dispatch({
      type: 'UI_NOTIFICATION',
      notification: 'Your password has been changed!'
    });
    resetForm();
  } catch({ error }) {
    const errors = {
      'Failed to fetch': 'The server is not responding. Please try again later.',
      'Password is wrong': 'The old password you entered is incorrect. Please try again.',
      'Wrong password': 'The old password you entered is incorrect. Please try again.',
      'Email address is already in use': 'This email is already in use. Please pick another one.',
    }
    if (/wrong/i.test(error)) {
      setFieldError('password', 'incorrect');
    } else {
      store.dispatch({
        type: 'UI_ERROR',
        errorMessage: errors[error] || 'Error. Please try again.',
        error,
      });
    }
  }
}
